import React, {useState} from 'react';
import {Iterable} from 'immutable';

import {Card, DropdownItem, IconButton, WithTooltip} from '@albert-io/atomic';
import MarkdownRendererV2 from 'generic/MarkdownRendererV2/MarkdownRendererV2.react';

import './free-form.scss';

interface FreeFormProps {
  content: any;
  name: string;
}

const FreeForm = ({content, name}: FreeFormProps) => {
  const [isHidden, setIsHidden] = useState(true);
  const freeFormContent = Iterable.isIterable(content) ? content.toJS() : content;

  let freeFormText = freeFormContent.text;
  if (!freeFormText) {
    freeFormText = 'No content entered.';
  }

  return (
    <Card className='rounded-x1'>
      <DropdownItem
        as='button'
        bold={false}
        onClick={(e) => {
          e.stopPropagation();
          setIsHidden(!isHidden);
        }}
        className='free-form__dropdown-item rounded-x1 p-x1'
        data-testid='free-form__expandable-item'
      >
        <WithTooltip placement='top' content={isHidden ? 'Expand' : 'Collapse'}>
          <IconButton
            as='div'
            size='s'
            aria-hidden
            icon={isHidden ? 'chevron-right' : 'chevron-down'}
          />
        </WithTooltip>
        <MarkdownRendererV2 className='ml-x2 py-x1 text-wrap' text={name} />
      </DropdownItem>
      {!isHidden && (
        <div className='px-x2 pt-x1 pb-x2'>
          <MarkdownRendererV2 text={freeFormText} data-testid='free-form__markdown-renderer' />
        </div>
      )}
    </Card>
  );
};

export default FreeForm;
